import { render, staticRenderFns } from "./ZGRanking1.vue?vue&type=template&id=12f65d63&scoped=true"
import script from "./ZGRanking1.vue?vue&type=script&lang=js"
export * from "./ZGRanking1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f65d63",
  null
  
)

export default component.exports